export default __webpack_public_path__ + "static/media/img-login.bb9b43de.png";